// @flow
import { Td, Tr } from "../../../element/Table";
import { ValueSelect } from "../../../element/ValueSelect";
import { TextInput } from "../../../element/Input";
import { RemoveButton } from "../../../element/Button";
import { CIDR_PROMPT } from "./lib";
import { InlineDialogResourceSelector } from "../../../element/selection/InlineDialogResourceSelector";

import type { AccessResourcesHook } from "../../../hoc/AccessControl";
import type { AccessControlTarget, BbTargetKinds } from "../../../../api/type";

export type DbsAccessControlRuleEdit = {
    source: AccessControlTarget;
    description: string;
}

export type DbAccessControlTableRowProps = {
    +item: DbsAccessControlRuleEdit,
    +onChange: (rule: DbsAccessControlRuleEdit) => void,
    +errorText?: ?string,
    +onRemove: () => void,
    +accessControlResources: AccessResourcesHook,
}

export const SET_TO_DEFAULT_SERVER_GROUP = 'DEFAULT';

export const DbsAccessControlTableRow = (
    { item, onChange, errorText, onRemove, accessControlResources, }: DbAccessControlTableRowProps
): React$Node => {
    const { source, description } = item;
    const { options, typeOptions, clientIp } = accessControlResources;

    return (
        <Tr>
            <Td>
                <ValueSelect
                    size='sm'
                    selected={source.kind}
                    options={typeOptions}
                    onSelect={(nextType: BbTargetKinds) => {
                        onChange({ ...item, source: { kind: nextType, value: nextType === 'clientIp' ? (clientIp.clientIp || '') : '' }});
                    }}
                />
            </Td>
            <Td resourceName={true}>
                {source.kind === 'any'
                    ? <div className='flex flex-row items-center h-8 ml-4'>
                        <span>Allow all traffic</span>
                    </div>
                    : null}
                {source.kind === 'addr'
                    ? <TextInput
                        label='IP Subnet'
                        size='sm'
                        helperText={CIDR_PROMPT}
                        errorText={errorText}
                        value={source.value}
                        onChange={(value: string) => onChange({ ...item, source: { kind: 'addr', value }})}
                    />
                    : null}
                {source.kind === 'clientIp'
                    ? <TextInput
                        disabled={true}
                        size='sm'
                        errorText={errorText}
                        value={source.value}
                    />
                    : null}
                {source.kind === 'other'
                    ? <TextInput
                        label='Other'
                        size='sm'
                        errorText={errorText}
                        value={source.value}
                        onChange={(value: string) => onChange({ ...item, source: { kind: 'other', value }})}
                    />
                    : null}
                {source.kind in options
                    ? <InlineDialogResourceSelector
                        kind={source.kind}
                        value={source.value}
                        onChange={(value) => onChange({ ...item, source: { kind: source.kind, value }})}
                    />
                    : null}
            </Td>
            <Td>
                <TextInput
                    value={description}
                    onChange={(description: string) => onChange({ ...item, description })}
                    size='sm'
                    className='w-full'
                    placeholder='Description (optional)'
                />
            </Td>
            <Td>
                <RemoveButton size='sm' onClick={onRemove}/>
            </Td>
        </Tr>
    )
};